module.exports = __webpack_public_path__ + "static/media/diners.d03a6d59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment-methods/diners.png
// module id = 1304
// module chunks = 0